// src/routes/AppRoutes.js
import React from 'react'
import { Routes, Route } from 'react-router-dom'

// Public pages
import LandingPage        from '../pages/LandingPage'
import LoginPage          from '../pages/LoginPage'
import RegisterPage       from '../pages/RegisterPage'

// ★ Public page: guest-side Quick Pay (payer scans QR → lands here)
import QuickPayGuestPage  from '../pages/QuickPayGuestPage'

// Import the old PrivateLayout file
import PrivateLayout      from '../layouts/PrivateLayout'

// Private pages
import DashboardHome       from '../components/DashboardHome'
import SendMoneyPage       from '../pages/SendMoneyPage'
import RequestMoneyPage    from '../pages/RequestMoneyPage'
import PendingRequestsPage from '../pages/PendingRequestsPage'
import HistoryPage         from '../pages/HistoryPage'

// NEW: SocialPage
import SocialPage          from '../pages/SocialPage'

// NEW: MyPayoutsPage
import MyPayoutsPage       from '../pages/MyPayoutsPage'

// ★ Logged-in page: user generates Quick-Pay link + QR
import QuickPayGeneratePage from '../pages/QuickPayGeneratePage'

// ★ NEW pages for Scheduled Payments
import ScheduledPaymentsPage from '../pages/ScheduledPaymentsPage'  // list / manage
import SchedulePaymentPage   from '../pages/SchedulePaymentPage'    // create / edit

function AppRoutes () {
  return (
    <Routes>
      {/* Public routes */}
      <Route path='/'            element={<LandingPage />} />
      <Route path='/login'       element={<LoginPage />} />
      <Route path='/register'    element={<RegisterPage />} />

      {/* ───────────────────────────────────────────────────────
          Quick-Pay guest page
          - old spec:  /pay/:token
          - backend generates: /quickpay/:token
         ─────────────────────────────────────────────────────── */}
      <Route path='/pay/:token'      element={<QuickPayGuestPage />} />
      <Route path='/quickpay/:token' element={<QuickPayGuestPage />} />

      {/* Private routes use the old PayMe PrivateLayout */}
      <Route element={<PrivateLayout />}>
        <Route path='/dashboard'        element={<DashboardHome />} />
        <Route path='/send-money'       element={<SendMoneyPage />} />
        <Route path='/request-money'    element={<RequestMoneyPage />} />
        <Route path='/pending-requests' element={<PendingRequestsPage />} />
        <Route path='/history'          element={<HistoryPage />} />

        {/* NEW: Social Page route */}
        <Route path='/social'           element={<SocialPage />} />

        {/* NEW: My Payouts route */}
        <Route path='/my-payouts'       element={<MyPayoutsPage />} />

        {/* ★ NEW: logged-in user → generate Quick-Pay QR/link */}
        <Route path='/quickpay/new'     element={<QuickPayGeneratePage />} />

        {/* ★★★ Scheduled Payments routes */}
        <Route path='/scheduled-payments' element={<ScheduledPaymentsPage />} />
        <Route path='/schedule-payment/:id?' element={<SchedulePaymentPage />} />

        {/* Alias for “/schedule/new” so older buttons work */}
        <Route path='/schedule/new' element={<SchedulePaymentPage />} />   {/* ★ NEW */}
      </Route>

      {/* Optionally handle unmatched routes */}
      {/* <Route path='*' element={<NotFoundPage />} /> */}
    </Routes>
  )
}

export default AppRoutes
